import { render, staticRenderFns } from "./Info1.vue?vue&type=template&id=1ac23cbc&scoped=true&"
import script from "./Info1.vue?vue&type=script&lang=js&"
export * from "./Info1.vue?vue&type=script&lang=js&"
import style0 from "./Info1.vue?vue&type=style&index=0&id=1ac23cbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac23cbc",
  null
  
)

export default component.exports